<template>
  <div>
    <simple-header
      :label="$t('global.back')"
      @click="$router.back()"
    />
    <div v-if="!product">
      {{ $t('global.loading') }}
    </div>
    <div class="Container" v-else>
      <!-- Product presentation -->
      <div class="Product-Wrapper">
        <div class="Carousel">
          <img :src="shopifyProduct.images[0].src" :alt="`${product.title} `" />
        </div>

        <div class="Info">
          <div class="Upper-Infos">
            <div class="Title">
              {{ product.title }}
              <img :src="colorChip" />
            </div>

            <div class="SubTitle">
              {{ product.naming }} {{ product.naming ? '-' : '' }} {{ product.region }}
            </div>

            <div class="Millesime">
              {{ product.millesime }}
            </div>

            <div class="domain">
              {{ product.domainName }}
            </div>

            <div class="Price">{{ price }} €</div>

            <div class="Quantity-Container">
              <button type="button" v-if="$mq === 'mobile'" @click="handleQuantity('decr')">
                -
              </button>
              <input type="number" v-model="quantity" class="Quantity" />
              <button type="button" v-if="$mq === 'mobile'" @click="handleQuantity('incr')">
                +
              </button>
            </div>

          </div>


          <div class="Teaser-Description">
            <VvRichText :document="product.shopTeaser" />
          </div>

          <div class="Add-To-Cart-Container">
            <div class="Add-To-Cart" @click="addToBasket" v-if="!$store.state.shop.isLoading && !isSoldOut">
              {{ $t('shop.product.addToCart') }}
            </div>
            <div class="Add-To-Cart SoldOut"  v-if="!$store.state.shop.isLoading && isSoldOut">
              {{ $t('shop.soldOut') }}
            </div>
            <div class="Loader" v-if="$store.state.shop.isLoading" >
              <loader />
            </div>
          </div>
        </div>
      </div>

      <!-- Know more -->
      <div class="Know-More">
        <div class="Title-Wrapper">
          <div class="Title">
            <div class="Title-Text">{{ $t('shop.product.knowMore') }}</div>
            <div class="Background" />
          </div>
        </div>
        <div class="Arrow" />
      </div>


      <div class="Description">
        <div class="Description-Domain">
          <div class="Box-Title">
            {{ $t('shop.product.domainsTitle')}}
          </div>

          <div class="Container">
            <VvRichText :document="product.domaineDescription" />

            <img :src="product.imageDomain" v-if="product.imageDomain" @click="openOverlay" />
            <div ref="richTextOverlay" v-if="product.imageDomain" :class="['rich-text-overlay', `rich-text-${this.$mq}`]" @click.stop="closeOverlay">
              <span ref="richTextCloseButton" class="rich-text-close-button" @click.stop="closeOverlay">X</span>
              <img :src="product.imageDomain" class="rich-text-overlay-img" />
            </div>
          </div>
        </div>

        <div class="Left-Column">
          <div class="Advices">
            <div>
              <div class="Box-Title">
                {{ $t('shop.product.degustationTitle') }}
              </div>
            </div>

            <div class="Advices-Container">
              <div class="Duration">
                <img :src="clockImg" height="120" width="120" />
                <span>{{ product.degustationDuration }}</span>
              </div>

              <div class="Temperature">
                <img :src="tempImg" height="120" width="120" />
                <span>{{ product.degustationTemperature }}</span>
              </div>
            </div>
          </div>

          <div class="Accords-Container">
            <div class="Box-Title">
              {{ $t('shop.product.accordsTitle') }}
            </div>
            <div class="Accords">
              <VvRichText :document="product.accordsDegustation" :useOverlay="false" :useMargin="true" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'

import shopMixin from '@/mixins/shop'
import VvRichText from '@/components/common/VvRichText'
import SimpleHeader from '@/components/navigation/SimpleHeader'
import Loader from "@/components/common/Loader";

import BullesRose from '@/assets/bottleChip/BullesRose.png'
import BullesBlanc from '@/assets/bottleChip/BullesBlanc.png'
import Blanc from '@/assets/bottleChip/Blanc.png'
import Doux from '@/assets/bottleChip/Doux.png'
import Rose from '@/assets/bottleChip/Rose.png'
import Rouge from '@/assets/bottleChip/Rouge.png'

export default {
  name: 'Product',
  components: {
    Loader,
    VvRichText,
    SimpleHeader
  },
  mixins: [shopMixin],
  data() {
    return {
      showAddModal: false,
      quantity: 1
    }
  },
  computed: {
    ...mapGetters([
      'getBottleById'
    ]),
    colorChip() {
      if (!this.product) return null

      switch (this.product.type) {
        case "Blanc":
          return require('@/assets/bottleChip/Blanc.png');
        case "Rosé":
          return require('@/assets/bottleChip/Rose.png');
        case "Rouge":
          return require('@/assets/bottleChip/Rouge.png');
        case "Doux":
          return require('@/assets/bottleChip/Doux.png');
        case "Bulles Rosé":
          return require('@/assets/bottleChip/BullesRose.png');
        case "Bulles Blanc":
          return require('@/assets/bottleChip/BullesBlanc.png');
        default:
          return null;
      }
    },
    shopifyProduct() {
      return this.$store.state.shop.bottles.find(bottle => bottle.id === this.$route.params.productId)
    },
    variant() {
      if (!this.shopifyProduct) return

      return this.shopifyProduct.variants[0]
    },
    isSoldOut() {
      if (!this.shopifyProduct) return

      return !this.shopifyProduct.variants[0].available
    },
    product() {
      if (!this.variant) return

      const sku = this.variant.sku

      return this.getBottleById(sku)
    },
    price() {
      const { amount } = this.variant.priceV2

      if (amount < 10) return `${amount.toString().padEnd(3, '.').padEnd(4, '0')}`
      else return `${amount.toString().padEnd(3, '.').padEnd(5, '0')}`
    },
    clockImg() {
      return require('@/assets/Garder.png')
    },
    tempImg() {
      return require('@/assets/Temperature.png')
    }
  },
  methods: {
    addToBasket() {
      this.addToCart(this.variant.id, this.quantity, 0)
    },
    handleQuantity(method) {
      if (method === 'incr') {
        this.quantity++
      } else {
        if (this.quantity > 1) {
          this.quantity--
        }
      }
    },
    openOverlay() {
      const overlay = this.$refs.richTextOverlay
      const posY = window.pageYOffset

      overlay.classList.add('displayOverlay')
      overlay.style.top = `${posY}px`
    },
    closeOverlay() {
      const overlay = this.$refs.richTextOverlay

      overlay.classList.remove('displayOverlay')
      overlay.style.top = '0'
    },
  },
  mounted() {
    
  }
}
</script>

<style lang="scss">
@import '@/assets/styles/_variables.scss';

.contentful-image-container {
  width: 200px;
  display: inline-block;
  margin-left: 10px;
  margin-right: 10px;

  .contentful-image {
    height: 200px;
    width: 200px;
    max-width: 200px !important;
  }
}

.Accords-Container .rich-text-content {
  text-align: center;

  & p:empty {
    display: none;
  }
}

.Accords {
  display: flex;
  justify-content: center;
  flex-direction: row;
}

.Container {
  font-family: Helvetica, Oblique;

  padding-bottom: 20px;

  .Product-Wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background-color: #DDE0F3;
    color: black;
    padding: 80px 0 80px 0;
    box-shadow: 0 20px 20px #00000029;

    @media (max-width: 450px) {
      flex-direction: column;
      align-items: center;
      padding-bottom: 60px;
    }

    .Carousel {
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        max-width: 500px;
        height: auto;

        @media (max-width: 450px) {
          max-width: 100%;
        }
      }
    }

    .Info {
      padding-right: 50px;
      box-sizing: border-box;
      max-width: 40%;

      @media (max-width: 450px) {
        max-width: none;
        padding-right: 20px;
        padding-left: 20px;
      }

      .Upper-Infos {
        border-bottom: 2px solid black;

        .Title {
          font-size: 41px;
          font-weight: bold;
          letter-spacing: 2px;
          color: black;
          font-family: Helvetica;
        }

        .SubTitle {
          font-size: 18px;
          display: inline-block;
          padding-right: 20px;
          box-sizing: border-box;
          letter-spacing: 1px;
          font-style: italic;
          font-family: Helvetica;
        }

        .Millesime {
          margin-bottom: 5px;
          font-size: 15px;
          font-family: Helvetica;
          margin-top: 15px;
        }

        .domain {
          font-size: 30px;
          font-family: Helvetica, sans-serif;
        }

        .Price {
          margin-top: 10px;
          font-size: 30px;
          padding-bottom: 5px;
          margin-bottom: 10px;
          font-weight: bold;
          font-family: Helvetica;
        }

        .Quantity-Container {
          display: flex;
          flex-direction: row;
          margin-bottom: 10px;
          width: 60px;
          height: 49px;

          @media (max-width: 450px) {
            width: 90px;
          }

          padding-left: 10px;
          border: 1px solid black;

          .Quantity {
            background-color: #DDE0F3;
            margin-left: 10px;
            border: none;
            width: 30px;
            height: 46px;
            font-size: 1.5em;
          }

          button {
            width: 20px;
            border: none;
            background-color: #DDE0F3;
          }
        }
      }

      .Add-To-Cart-Container {
        position: relative;

        @media (max-width: 450px) {
          min-width: 100%;
          display: flex;
          justify-content: center;
        }

        .Add-To-Cart {
          margin-top: 40px;
          cursor: pointer;
          font-size: 16px;
          display: inline-block;
          padding: 10px 30px;
          background-color: $primary;
          color: white;
          border-radius: 36px;

          @media (max-width: 450px) {
            position: absolute;
            top: 0px;
          }

          &.SoldOut {
            background-color: $dark;
            cursor: not-allowed;
          }
        }

        .Loader {
          margin-top: 40px;
        }
      }

      .Teaser-Description {
        margin-top: 30px;
        letter-spacing: 1px;
        line-height: 25px;
        font-family: Helvetica;
      }
    }
  }

  .Know-More {
    margin-top: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .Title-Wrapper {
      text-align: center;

      .Title {
        position: relative;
        display: inline-block;
        color: black;
        font-weight: bold;
        font-size: 40px;
      }

      .Title-Text {
        position: relative;
        z-index: 2;
      }

      .Background {
        content: '';
        display: block;
        height: 15px;
        width: 120%;
        position: absolute;
        bottom: -1px;
        left: -10%;
        z-index: 1 !important;
        background-color: #DDE0F3;
      }
    }

      .Arrow {
        border-left: 4px solid black;
        border-bottom: 4px solid black;
        width: 15px;
        height: 15px;
        transform: rotate(-45deg);
        margin-top: 20px;
      }
  }



  .Related-Product {
    margin-top: 100px;
  }

  .Description {
    display: flex;
    flex-direction: row-reverse;
    justify-content: center;
    margin-top: 86px;

    @media (max-width: 450px) {
      flex-direction: column;
      margin-left: 10px;
      margin-right: 10px;
    }

    .Box-Title {
      display: inline-block;
      width: unset;
      padding: 0 5px;
      border-bottom: 2px solid black;
      margin-bottom: 44px;
      font-size: 27px;
    }

    .Left-Column {
      display: flex;
      flex-direction: column;
      vertical-align: center;
      max-width: 50%;

      @media (max-width: 450px) {
        max-width: 100%;
        margin-right: 0px;
        padding-left: 20px;
        padding-right: 20px;
      }

      .Advices {
        display: flex;
        flex-direction: column;
        text-align: center;
        margin-bottom: 56px;
      }

      .Advices-Container {
        display: flex;
        justify-content: center;

        .Duration {
          display: flex;
          flex-direction: column;
          margin-right: 20px;
          align-items: center;
          max-width: 50%;

          span {
            margin-top: 15px;
            word-break: break-word;
          }
        }

        .Temperature {
          display: flex;
          flex-direction: column;
          margin-left: 40px;
          align-items: center;

          span {
            margin-top: 15px;
          }
        }
      }

      .Accords-Container {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    }

    .Description-Domain {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      max-width: 50%;

      @media (max-width: 450px) {
        margin-left: 0px;
        max-width: 100%;
        padding-right: 20px;
        padding-left: 20px;
      }

      .Container {
        display: flex;
        flex-direction: column;
        max-width: 90%;

        @media (max-width: 450px) {
          max-width: 100%;
          margin-bottom: 110px;
        }

        img {
          margin-top: 80px;
        }
      }
    }
  }
}

.rich-text-overlay {
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  width: 100%;
  height: auto;
  left: 0;
  z-index: 9000;
  display: none;
  padding-bottom: 80px;

  &.displayOverlay {
    display: block;
  }

  &.rich-text-desktop {
    width: 75%;
    margin-left: 12.5%;
    margin-right: 12.5%;
  }

  .rich-text-overlay-img {
    width: 100%;
    height: auto;
    position: relative;
    top: 20px;
  }

  .rich-text-close-button {
    color: #d10a4a;
    padding: 5px;
    font-size: 20px;
    background-color: #DDE0F3;
    border-radius: 50%;
    position: relative;
    width: 25px;
    height: 25px;
    text-align: center;
    vertical-align: middle;
    top: 10px;
    right: 10px;
    float: right;

    &:hover {
      cursor: pointer;
    }
  }
}
</style>
